import { Directive, OnDestroy } from '@angular/core';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';

// Taken from https://github.com/angular/components/issues/10079#issuecomment-947360027

@Directive({
    selector: 'input[matAutocomplete]',
})
export class AutocompletePositionDirective implements OnDestroy {

    constructor(private readonly matAutocompleteTrigger: MatAutocompleteTrigger) {
        window.addEventListener('scroll', this.scrollEvent, true);
    }

    ngOnDestroy(): void {
        window.removeEventListener('scroll', this.scrollEvent, true);
    }

    private scrollEvent = (event: Event): void => {
        if (this.matAutocompleteTrigger == null) {
            return;
        }
        const isSelf = (event.target as HTMLElement)?.classList?.contains('mat-mdc-autocomplete-panel');
        if (this.matAutocompleteTrigger.panelOpen && !isSelf) {
            this.matAutocompleteTrigger.closePanel();
        }
    };
}
